import { Button } from "@radix-ui/themes";
import { PlusIcon } from "@radix-ui/react-icons";
import { useManagerContext } from "./context";

type CreateButtonProps = {
  label?: string;
};

export function CreateButton({ label = "Create" }: CreateButtonProps) {
  const { openCreate } = useManagerContext();

  return (
    <Button onClick={openCreate}>
      <PlusIcon />
      {label}
    </Button>
  );
}
